/* eslint-disable quotes */
import { snakelize, camelize } from "../../../helpers/object"

export default ($axios: any): any => ({
  async store(data: any) {
    return camelize(await $axios.post(`/business/contact`, snakelize(data)))
  }
})
